import BaseApi from "./index";
import { postFile } from "./fetch";
import qs from "qs";

class PublicApi extends BaseApi {
  getCaptcha = () => this.request("/auth/captcha");
  getToken(config) {
    config.headers = {
      // Authorization: 'Basic ' + window.btoa('SyncClient:syncRenz12345'),
      "Content-Type": "application/x-www-form-urlencoded",
      "x-requested-with": "XMLHttpRequest",
    };
    config.data = qs.stringify(config.data);
    return this.request("/auth/oauth/token", "POST", config);
  }
  getRsaPublicKey = () => this.request("/auth/rsa");
  getDictionary = (config) => {
    return this.request("/common/dictionary", "GET", config);
  };
  getSystemGlobal = () => {
    return this.request("/wrms/systemGlobal/info", "GET");
  };
  currentAccount = (config) => {
    return this.request(`/auth/platform/currentAccount`, "GET", config);
  };
  menuVO = (platformCode) => {
    return this.request(`/auth/menu/MenuVO/${platformCode}`, "GET");
  };
  resetPassword = (config) => {
    return this.request(`/auth/account/resetPassword`, "POST", config);
  };
  resetPwd = (config) => {
    return this.request(`/auth/account/resetPasswordForTemp`, "POST", config);
  };
  getAttachment(config) {
    return this.request(`/common/attachment`, "GET", config);
  }
  getAttachmentById(id) {
    return this.request(`/common/attachment/${id}`, "GET");
  }
  getAttachmentStream(id) {
    return this.request(`/common/attachment/stream/${id}`, "GET");
  }
  getAttachmentDownload(id) {
    return this.request(`/common/attachment/download/${id}`, "GET");
  }
  deleteImage = (id) => this.request(`/common/attachment/delete/${id}`, "POST");
  getImportData = (config) => {
    return this.request(`/common/excelImportDefine`, "GET", config);
  };
  downLoadImportData = (id) => {
    return this.requestFile(`/common/attachment/download/${id}`, "GET");
  };
  downloadByBizId = (id) => {
    return this.requestFile(`/common/attachment/downloadByBizId/${id}`, "GET");
  };
  uploadFile = (data, config) => {
    return postFile(`/common/attachment/uploadFile`, data, config);
  };
  importDefine = (bizCode, attachmentId, config) =>
    this.request(
      `/common/excelImportDefine/importFile/${bizCode}/${attachmentId}`,
      "POST",
      config
    );
  getQueryData = (code, config) => {
    return this.request(`/common/query/data/${code}`, "GET", config);
  };
  getCacheData = (code, config) => {
    return this.request(`/common/cacheDataManage/query/${code}`, "GET", config);
  };
  getAccountInfo = (config) => {
    return this.request("/auth/platform/getAccountInfo", "GET", config);
  };
  getGenerateReport = (config) => {
    return this.request(
      "/common/reportGenerateEngine/generateReport",
      "GET",
      config
    );
  };
  receiveErrorMessage = (config) => {
    return this.request("/ismp-web/receiveMessage", "POST", config);
  };
  clearToken = (config) => {
    return this.request("/auth/clearToken", "POST", config);
  };

  getUserInfo = (config) => {
    return this.request("/auth/account/getAccountInfo", "GET", config);
  };
}

export default new PublicApi();
